import { connect } from 'react-redux';
import PaymentComponent from './PaymentComponent';
import { getTranslation } from "../../../reducers/common/localization";
import {
    getOrgName,
    getOrgType,
    getOrgPrice,
    getOrgPermissions,
    getOrgCountryCode
} from '../../../reducers/organization/organization';
import {
    getCurrentContinent,
    setCurrentContinent,
    getCountriesData,
    getContinentsData,
    setCurrentContinentByCountry
} from '../../../reducers/common/location';

const mapStateToProps = state => {
    return {
        translation: getTranslation(state),
        orgName: getOrgName(state),
        orgType: getOrgType(state),
        price: getOrgPrice(state),
        orgPermissions: getOrgPermissions(state),
        orgCountryCode: getOrgCountryCode(state),
        continentCode: getCurrentContinent(state),
        continents: getContinentsData(state),
        countries: getCountriesData(state)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onContinentSet: (continentCode) => {
            dispatch(setCurrentContinent(continentCode));
        },
        setCurrentContinentByCountry: (countryCode) => {
            dispatch(setCurrentContinentByCountry(countryCode));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentComponent);



// WEBPACK FOOTER //
// ./src/components/commonComponents/paymentComponent/PaymentComponent.container.js